import { render, staticRenderFns } from "./ScoopResult.vue?vue&type=template&id=4e4129be&scoped=true&"
import script from "./ScoopResult.vue?vue&type=script&lang=js&"
export * from "./ScoopResult.vue?vue&type=script&lang=js&"
import style0 from "./ScoopResult.vue?vue&type=style&index=0&id=4e4129be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4129be",
  null
  
)

export default component.exports